import React from 'react';
import { Skeleton } from '../../../components/ui/SkeletonLoader';

const AnalysisRowSkeleton = () => (
  <div className="bg-muted/30 border border-border rounded-lg p-4 flex flex-col sm:flex-row sm:items-center gap-3">
    <div className="flex-1 space-y-2">
      <Skeleton className="h-5 w-3/5" />
      <div className="flex gap-3">
        <Skeleton className="h-4 w-24" />
        <Skeleton className="h-4 w-20" />
      </div>
    </div>
    <div className="flex items-center gap-3 flex-shrink-0">
      <Skeleton className="h-7 w-20 rounded-full" />
      <Skeleton className="h-7 w-16 rounded-full" />
      <Skeleton className="h-8 w-24 rounded-lg" />
    </div>
  </div>
);

export const AnalysisListSkeleton = ({ count = 4 }) => (
  <div className="space-y-3">
    {Array.from({ length: count })?.map((_, i) => (
      <AnalysisRowSkeleton key={i} />
    ))}
  </div>
);

export const AnalysisListSpinner = () => (
  <div className="flex flex-col items-center justify-center py-12 gap-3">
    <div className="relative">
      <div className="w-12 h-12 rounded-full border-4 border-primary/20 border-t-primary animate-spin" />
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-3 h-3 rounded-full bg-primary/40 animate-pulse" />
      </div>
    </div>
    <p className="text-sm text-muted-foreground">Loading analyses...</p>
  </div>
);

export const AnalysesEmptyState = ({ searchQuery = '', onStartAnalysis }) => (
  <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
    <div className="relative mb-5">
      <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center">
        <svg className="w-10 h-10 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
        </svg>
      </div>
      {!searchQuery && (
        <div className="absolute -top-1 -right-1 w-8 h-8 rounded-full bg-cyan-500/20 border-2 border-background flex items-center justify-center">
          <svg className="w-4 h-4 text-cyan-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z" />
          </svg>
        </div>
      )}
    </div>

    <h3 className="text-lg font-semibold text-foreground mb-2">
      {searchQuery ? 'No analyses found' : 'No analyses yet'}
    </h3>
    <p className="text-sm text-muted-foreground max-w-xs mb-6">
      {searchQuery
        ? `No results match "${searchQuery}". Try a different address or suburb.`
        : 'Your AI-powered property analyses will appear here. Start by entering a property URL or details above.'}
    </p>

    {!searchQuery && onStartAnalysis && (
      <button
        onClick={onStartAnalysis}
        className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary text-primary-foreground rounded-lg text-sm font-semibold hover:bg-primary/90 transition-colors shadow-md shadow-primary/20"
      >
        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
        </svg>
        Start Your First Analysis
      </button>
    )}
  </div>
);

export default AnalysisListSkeleton;
